<!-- <div class="border-bottom border-solid border-[#CBDBE4] border-t-0 border-l-0 border-r-0">
  <input
    type="text"
    class="w-full px-4 py-3 text-[13px] border-none outline-none"
    placeholder="Search..."
    [ngModel]="searchQuery"
    (ngModelChange)="onSearchQueryChange($event)"
  />
</div> -->
<div class="filter-container" (click)="$event.stopPropagation()">
  <!-- Restored Filter Chips -->
  <!-- Filter Chips with Remove Option -->
  @if (appliedChips?.length) {
    <div class="p-3 flex flex-wrap gap-2 border-bottom">
      <div>
        <label
          class="form-check-label mr-10 py-2 text-6 font-weight-500"
          for="a"
        >
          {{ 'CUSTOMER.PREDEFINED_FILTERS' | translate }}
        </label>
      </div>
      <!-- <mat-chip-list> -->
      @for (chip of appliedChips; track chip) {
        <mat-chip
          selected
          class="m-1 filter-input-chip flex items-center text-center !bg-[rgba(3,192,252,0.12)]"
          removable="true"
          (removed)="removeChip(chip.key, chip.value)"
        >
          {{ chip.label }}
          <mat-icon matChipRemove class="ml-1 text-lg leading-none !text-red"
            >close</mat-icon
          >
        </mat-chip>
      }
      <!-- </mat-chip-list> -->
    </div>
  }

  <div class="">
    <div
      class="flex gap-2 p-3 items-center border-bottom border-solid border-[#CBDBE4] border-t-0 border-l-0 border-r-0"
    >
      <label class="text-[#92A0A8] text-[14px] font-medium">{{
        'REPORTING.Filter Name:' | translate
      }}</label>
      <span class="font-semibold text-[#364F6B] text-[14px]">{{
        getTranslatedText('REPORTING.' + filterName) || filterName
      }}</span>
    </div>
    @if (
      filterName !== 'Sales Order per Region' &&
      filterName !== 'Account statement'
    ) {
      <div
        class="flex gap-2 items-center p-3 border-bottom border-solid border-[#CBDBE4] border-t-0 border-l-0 border-r-0"
      >
        <label class="text-[#92A0A8] text-[14px] font-medium min-w-[120px]">
          {{ 'REPORTING.Graph Type:' | translate }}</label
        >

        <div class="relative inline-block w-full">
          <button
            class="font-semibold text-[#364F6B] text-[14px] px-2 py-1 w-[130px] flex justify-between items-center border-none outline-none bg-transparent"
            (click)="toggleCustomTypeDropdown()"
          >
            {{
              getTranslatedText('REPORTING.' + selectedCustomType) ||
                selectedCustomType
            }}<span class="ml-2">&#x25BC;</span>
          </button>
          @if (isCustomTypeDropdownOpen) {
            <div
              class="absolute bg-white border border-gray-300 mt-1 rounded-md shadow-lg z-10 w-full"
            >
              <div class="p-2">
                <input
                  matInput
                  type="text"
                  [(ngModel)]="customTypeSearch"
                  placeholder="Search types..."
                  (input)="filterCustomTypes()"
                  class="w-full p-2"
                />
              </div>

              <ul class="text-sm text-gray-700 list-none !pl-4">
                @for (
                  customType of filteredCustomTypeOptions;
                  track customType
                ) {
                  <li
                    (click)="selectCustomType(customType)"
                    class="py-2 cursor-pointer flex items-center border-b border-solid border-[#E3ECF1] border-r-0 border-l-0 border-t-0"
                  >
                    <img
                      [src]="'assets/svg-icons/' + customType.svg"
                      alt="{{ customType.label }}"
                      class="mr-2"
                      width="20"
                      height="20"
                    />
                    <span>{{
                      getTranslatedText('REPORTING.' + customType.label) ||
                        customType.label
                    }}</span>
                  </li>
                }
                @if (filteredCustomTypeOptions.length === 0) {
                  <li class="py-2">No types found</li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <!-- <div class="p-3 border-bottom border-solid border-[#CBDBE4] border-t-0 border-l-0 border-r-0">
  <label class="text-[#92A0A8] text-[14px] font-medium">Saved Filters:</label>
  <div class="flex gap-2 mt-2">
    <span *ngFor="let filter of savedFilters" class="flex items-center space-x-2 border rounded-[5px] px-2 py-1 bg-[#ECF7FE]">
      <span class="flex items-center justify-center w-4 h-4 bg-[#3AA1FF] rounded-[5px] cursor pointer"></span>
      <span class="text-[13px] font-medium text-[#364F6B]">{{ filter }}</span>
      <button (click)="removeFilter(filter)" class="text-[#A4B5BE] border-none outline-none bg-transparent">x</button>
    </span>
  </div>
</div> -->
  <div class="acordion-filed">
    <mat-accordion>
      @if (
        filterName !== 'Lost Deals' &&
        filterName !== 'Quote Stages' &&
        filterName !== 'Quote -to-sales-order conversion' &&
        filterName !== 'Account statement' &&
        filterName !== 'Won Deal' &&
        filterName !== 'New Quotes' &&
        filterName !== 'New Leads' &&
        filterName !== 'Sales Tax' &&
        filterName !== 'Deal Velocity' &&
        filterName !== 'Deal Forecast' &&
        filterName !== 'Quote Stage Trend'
      ) {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title class="text-[#92A0A8] text-[14px] font-medium"
              >{{ 'COMMON.Categories' | translate }} &
              {{ 'COMMON.Subcategory' | translate }}</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div class="acordion-input">
            <span class="example-list-section">
              <ul class="pl-[10px] list-none max-h-[140px] overflow-y-auto">
                @for (category of categories; track category) {
                  <li class="min-h-[28px]">
                    <div class="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        class="checked:bg-[#03C0FC] ml-0 h-[18px] w-[18px]"
                        [(ngModel)]="category.selected"
                        (change)="toggleCategory(category)"
                      />
                      <span
                        class="text-[#364F6B] font-medium text-[15px]"
                        (click)="toggleSubcategories(category)"
                        >{{ category.name }}</span
                      >
                    </div>
                    @if (category.subcategories && category.showSubcategories) {
                      <ul class="ml-6 list-none pl-0">
                        @for (
                          subcategory of category.subcategories;
                          track subcategory
                        ) {
                          <li class="min-h-[28px]">
                            <div class="flex items-center gap-2">
                              <mat-icon class="invisible"></mat-icon>
                              <input
                                type="checkbox"
                                class="checked:bg-[#03C0FC] ml-0 h-[18px] w-[18px]"
                                [(ngModel)]="subcategory.selected"
                                (change)="
                                  toggleSubcategory(subcategory, category)
                                "
                              />
                              <span
                                class="text-[#364F6B] font-medium text-[15px]"
                                >{{ subcategory.name }}</span
                              >
                            </div>
                          </li>
                        }
                      </ul>
                    }
                  </li>
                }
              </ul>
            </span>
          </div>
        </mat-expansion-panel>
      }
      @if (filterName == 'Lost Deals' || filterName == 'Deal Forecast') {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'REPORTING.Deal Value' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <!-- <label for="deal_value" class="text-gray-500 text-sm font-medium">
        {{ "COMMON.Enter_a_Deal_Value" | translate }}
      </label> -->
            <input
              style="height: 42px; width: 223px"
              type="number"
              id="deal_value"
              class="value-input border border-gray-300 rounded px-2 py-1 w-full"
              [formControl]="singale_value"
              (change)="
                toggleDealValue($event, singale_value?.value, 'singale_value')
              "
              [placeholder]="'REPORTING.Enter value' | translate"
            />
          </div>
        </mat-expansion-panel>
      }

      @if (
        filterName == 'Sales overview' ||
        filterName == 'Sales Order per Region' ||
        filterName == 'Sales Order' ||
        filterName == 'Top customers' ||
        filterName == 'Sales Team'
      ) {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'COMMON.Items' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="acordion-search">
            <input
              class="acordion-search-input"
              [placeholder]="'REPORTING.Search by name' | translate"
              [(ngModel)]="itemsSearch"
            />
          </div>
          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of itemsData | search: itemsSearch; track item) {
                  <p class="!h-[28px]">
                    @if (item?.id) {
                      <mat-checkbox
                        [checked]="isItemsValueSelected(item?.id)"
                        (change)="toggleItemsValue($event, item)"
                      >
                        {{ item?.name }}
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }
      @if (
        filterName == 'Sales overview' ||
        filterName == 'Sales Order' ||
        filterName == 'Sales Order per Region' ||
        filterName == 'Quote Stages' ||
        filterName == 'Quote -to-sales-order conversion' ||
        filterName == 'Commissions' ||
        filterName == 'Account statement' ||
        filterName == 'Quote By Source' ||
        filterName == 'Top customers' ||
        filterName == 'New Quotes' ||
        filterName == 'Sales Team' ||
        filterName == 'Sales Forecast' ||
        filterName == 'Quote Stage Trend'
      ) {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'COMMON.Tags' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of contactTags; track item) {
                  <p class="!h-[28px]">
                    @if (item?.name) {
                      <mat-checkbox
                        [checked]="isContactValueSelected(item.id)"
                        (change)="toggleContactValue($event, item)"
                      >
                        {{ item?.name }}
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (
        filterName == 'New Quotes' ||
        filterName == 'Sales Tax' ||
        filterName == 'Quote Stage Trend'
      ) {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'QUOTE_TEMPLATE.Stages' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of allQuoteStagesList; track item) {
                  <p class="!h-[28px]">
                    @if (item?.name) {
                      <mat-checkbox
                        [checked]="isStagesSelected(item.id)"
                        (change)="toggleStagesValue($event, item)"
                      >
                        <span [style.color]="item?.color">{{
                          getTranslatedText('COMMON.' + item?.name) ||
                            item?.name
                        }}</span>
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (filterName == 'Sales Tax') {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'QUOTE_TEMPLATE.Taxes' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of taxListArr; track item) {
                  <p class="!h-[28px]">
                    @if (item?.name) {
                      <mat-checkbox
                        [checked]="isSalesTaxSelected(item.name)"
                        (change)="toggleSalesTaxValue($event, item)"
                      >
                        <span>{{ item?.name }}</span>
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (
        filterName == 'Lost Deals' ||
        filterName == 'Won Deal' ||
        filterName == 'Deal Velocity' ||
        filterName == 'Deal Forecast'
      ) {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'COMMON.Tags' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of allTagsArr; track item) {
                  <p class="!h-[28px]">
                    @if (item?.name) {
                      <mat-checkbox
                        [checked]="isDealTagsValueSelected(item.id)"
                        (change)="toggleDealTagsValue($event, item)"
                      >
                        {{ item?.name }}
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (filterName == 'New Leads') {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'COMMON.Tags' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of allLeadsTagsArr; track item) {
                  <p class="!h-[28px]">
                    @if (item?.name) {
                      <mat-checkbox
                        [checked]="isLeadTagsValueSelected(item.id)"
                        (change)="toggleLeadTagsValue($event, item)"
                      >
                        {{ item?.name }}
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (
        filterName == 'Sales overview' ||
        filterName == 'Sales Order' ||
        filterName == 'Sales Order per Region' ||
        filterName == 'Quote Stages' ||
        filterName == 'Quote -to-sales-order conversion' ||
        filterName == 'Quote By Source' ||
        filterName == 'Top customers' ||
        filterName == 'New Quotes' ||
        filterName == 'New Leads' ||
        filterName == 'Sales Team' ||
        filterName == 'Deal Velocity' ||
        filterName == 'Deal Forecast' ||
        filterName == 'Sales Forecast' ||
        filterName == 'Quote Stage Trend'
      ) {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'COMMON.Source' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of sourceOfContacts; track item) {
                  <p class="!h-[28px]">
                    @if (item?.id) {
                      <mat-checkbox
                        [checked]="isSourceValueSelected(item?.name)"
                        (change)="toggleSourceValue($event, item)"
                      >
                        {{ item?.name }}
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (
        filterName == 'Sales overview' ||
        filterName == 'Sales Order' ||
        filterName == 'Sales Order per Region' ||
        filterName == 'Quote Stages' ||
        filterName == 'Quote -to-sales-order conversion' ||
        filterName == 'Commissions' ||
        filterName == 'Quote By Source' ||
        filterName == 'Top customers' ||
        filterName == 'New Quotes' ||
        filterName == 'Sales Team' ||
        filterName == 'Sales Tax' ||
        filterName == 'Deal Velocity' ||
        filterName == 'Deal Forecast' ||
        filterName == 'Sales Forecast' ||
        filterName == 'Quote Stage Trend'
      ) {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'REPORTING.Region' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of regionArray; track item) {
                  <p class="!h-[28px]">
                    <mat-checkbox
                      [checked]="isRegionSelected(item?.region)"
                      (change)="toggleRegionSelection($event, item)"
                    >
                      <!-- {{ item?.region && item?.country ? '/' : '' }}{{ item?.country ? item?.country : '' }} -->
                      {{ item?.region ? item?.region : '' }}
                    </mat-checkbox>
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (filterName == 'Lost Deals') {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'REPORTING.Reason Lost' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of dealReasonsList; track item) {
                  <p class="!h-[28px]">
                    @if (item?.reason) {
                      <mat-checkbox
                        [checked]="isSelected(item)"
                        (change)="toggleReason($event, item)"
                      >
                        {{ item?.reason }}
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      <mat-expansion-panel class="py-2">
        <mat-expansion-panel-header>
          <mat-panel-title>{{
            'PAYMENTS.Members' | translate
          }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="acordion-search">
          <input
            class="acordion-search-input"
            [placeholder]="'PAYMENTS.SearchMembers' | translate"
            [(ngModel)]="contactSearchTags"
          />
        </div>
        <div class="acordion-input">
          <!-- (scroll)="onScroll($event)" -->
          <span class="example-list-section">
            <span>
              @for (
                item of merContactListArr | search: contactSearchTags;
                track item
              ) {
                <p class="!h-[28px]">
                  @if (
                    item?.fname !== null &&
                    item?.fname !== undefined &&
                    item?.fname !== ''
                  ) {
                    <mat-checkbox
                      [checked]="checkValueExistMember(selectedMember, item)"
                      (change)="getAccorValue($event, item, 'member')"
                      >{{ item?.fname || '' }} {{ item?.lname || '' }}
                    </mat-checkbox>
                  }
                </p>
              }
            </span>
          </span>
        </div>
      </mat-expansion-panel>

      @if (
        filterName !== 'Lost Deals' &&
        filterName !== 'Sales overview' &&
        filterName !== 'Sales Order' &&
        filterName !== 'Sales Order per Region' &&
        filterName !== 'Quote Stages' &&
        filterName !== 'Quote -to-sales-order conversion' &&
        filterName !== 'Commissions' &&
        filterName !== 'Account statement' &&
        filterName !== 'Won Deal' &&
        filterName !== 'Quote By Source' &&
        filterName !== 'Top customers' &&
        filterName !== 'New Quotes' &&
        filterName !== 'New Leads' &&
        filterName !== 'Sales Team' &&
        filterName !== 'Sales Tax' &&
        filterName !== 'Deal Velocity' &&
        filterName !== 'Deal Forecast' &&
        filterName !== 'Sales Forecast' &&
        filterName !== 'Quote Stage Trend'
      ) {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'Date Range' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="acordion-input">
            @if (dateRangeOptions?.length) {
              <div>
                <div class="flex flex-col gap-2 h-[150px] overflow-y-auto">
                  @for (option of dateRangeOptions; track option) {
                    <mat-checkbox
                      [checked]="selectedDateRange === option.value"
                      (change)="onDateRangeCheckboxChange($event, option.value)"
                      class="!m-0"
                    >
                      {{ option.label }}
                    </mat-checkbox>
                  }
                </div>

                <!-- Custom Date Range Input -->
                <!-- <div id="custom-date-id" class="custom-date-range w-full flex justify-end mt-[10px]">
          <mat-form-field appearance="outline">
            <mat-label>Select range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="Start date" [value]="startDate" (dateChange)="onStartDateChange($event)">
              <input matEndDate placeholder="End date" [value]="endDate" (dateChange)="onEndDateChange($event)">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div> -->
              </div>
            }
          </div>
        </mat-expansion-panel>
      }

      @if (filterName == 'Account statement') {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'COMMON.organization' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-search">
            <input
              class="acordion-search-input"
              [placeholder]="'ORGANIZATION.Search_for_organization' | translate"
              [(ngModel)]="organizationSearchTags"
            />
          </div>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (
                  item of allOrgArr | search: organizationSearchTags;
                  track item
                ) {
                  <p>
                    <mat-checkbox
                      [(ngModel)]="item.checked"
                      (change)="
                        getAccorValueOrganization(
                          $event,
                          { id: item.id, name: item.name },
                          'organization'
                        )
                      "
                    >
                      {{ item?.name }}
                    </mat-checkbox>
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (filterName === 'Account statement') {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'PAYMENTS.Contacts' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-search">
            <input
              class="acordion-search-input"
              [placeholder]="'Search Contacts' | translate"
              [(ngModel)]="contactSearchTagsNew"
            />
          </div>

          <div
            class="acordion-input"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="200"
            (scrolled)="loadAllOnScroll(currentPage)"
          >
            <span class="example-list-section">
              <span>
                @for (
                  item of merContactListArrNew | search: contactSearchTagsNew;
                  track item
                ) {
                  <p>
                    @if (item?.firstname) {
                      <mat-checkbox
                        [(ngModel)]="item.checked"
                        (change)="getAccorValueContact($event, item, 'contact')"
                      >
                        {{ item.firstname }} {{ item.lastname || '' }}
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (filterName === 'Account statement') {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'PAYMENTS.Status' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of accountStatementStatusFilter; track item) {
                  <p>
                    <mat-checkbox
                      [(ngModel)]="item.checked"
                      (change)="getstatusValue($event, item, 'organization')"
                    >
                      {{ item.name }}
                    </mat-checkbox>
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (filterName === 'Quote By Source') {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'COMMON.quote_status' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of quoteBySourceStatusFilters; track item) {
                  <p>
                    <mat-checkbox
                      [(ngModel)]="item.checked"
                      (change)="
                        getQuoteStatusValue($event, item, 'organization')
                      "
                    >
                      {{ item.name }}
                    </mat-checkbox>
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (
        filterName === 'Won Deal' ||
        filterName == 'New Leads' ||
        filterName == 'Deal Velocity' ||
        filterName == 'Deal Forecast' ||
        filterName == 'Lost Deals'
      ) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'COMMON.dealtype' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>
          <!-- <div class="acordion-search">
      <input class="acordion-search-input" placeholder="{{'LEADS.SEARCH_DEALTYPE' | translate}}">
  </div> -->
          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                <mat-radio-group>
                  @for (item of deal_typeArr; track item) {
                    <p>
                      <mat-radio-button
                        [checked]="deal_type_id?.includes(item.id)"
                        [value]="item"
                        (change)="getDealTypeData($event, item, 'deal_type')"
                      >
                        {{
                          getTranslatedText('DEAL_DETAILS.' + item?.name) ||
                            item?.name
                        }}
                      </mat-radio-button>
                    </p>
                  }
                </mat-radio-group>
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }
      @if (
        filterName === 'Won Deal' ||
        filterName == 'New Leads' ||
        filterName == 'Deal Velocity' ||
        filterName == 'Deal Forecast' ||
        filterName == 'Lost Deals'
      ) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'COMMON.dealstage' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>
          <!-- <div class="acordion-search">
      <input class="acordion-search-input"
          placeholder="{{'LEADS.Select a deal type before selecting a deal stage' | translate}}">
  </div> -->
          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of deal_stageArr; track item) {
                  <p>
                    <mat-checkbox
                      [checked]="deal_stage_id?.includes(item.id)"
                      (change)="getDealStageData($event, item, 'deal_stage')"
                      >{{
                        getTranslatedText('DEAL_DETAILS.' + item?.name) ||
                          item?.name
                      }}
                    </mat-checkbox>
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      @if (
        filterName !== 'Quote -to-sales-order conversion' &&
        filterName !== 'Sales Order' &&
        filterName !== 'Quote Stages' &&
        filterName !== 'Lost Deals' &&
        filterName !== 'Quote -to-sales-order conversion' &&
        filterName !== 'Commissions' &&
        filterName !== 'Won Deal' &&
        filterName !== 'Quote By Source' &&
        filterName !== 'New Quotes' &&
        filterName !== 'New Leads' &&
        filterName !== 'Deal Velocity' &&
        filterName !== 'Deal Forecast' &&
        filterName !== 'Sales Forecast' &&
        filterName !== 'Sales Tax' &&
        filterName !== 'Sales Team' &&
        filterName !== 'Quote Stage Trend'
      ) {
        <div>
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                filterName == 'Sales overview' ||
                filterName == 'Sales Order per Region' ||
                filterName == 'Account statement' ||
                filterName == 'Top customers'
                  ? ('QUOTE_TEMPLATE.Document Type' | translate)
                  : ('Conversion' | translate)
              }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="acordion-input">
              <div class="flex flex-col">
                <mat-radio-group>
                  @for (value of values; track value) {
                    <p class="!m-0">
                      <mat-radio-button
                        [checked]="selectedValue === value.name"
                        [value]="value.name"
                        (change)="onValueRadioChange($event)"
                        class="!m-0"
                      >
                        {{
                          getTranslatedText(
                            'LEADS.' + (value.name | titlecase)
                          ) || value.name
                        }}
                      </mat-radio-button>
                    </p>
                  }
                </mat-radio-group>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      }

      @if (filterName == 'Quote By Source') {
        <div>
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'QUOTE_TEMPLATE.Document Type' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="acordion-input">
              <div class="flex flex-col">
                <mat-radio-group>
                  @for (value of values; track value) {
                    <p class="!m-0">
                      <mat-radio-button
                        [checked]="selectedValue === value.name"
                        [value]="value.name"
                        (change)="onValueRadioChange($event)"
                        class="!m-0"
                      >
                        {{
                          getTranslatedText(
                            'LEADS.' + (value.name | titlecase)
                          ) || value.name
                        }}
                      </mat-radio-button>
                    </p>
                  }
                </mat-radio-group>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      }

      <!-- <div class="flex flex-col">
  <mat-checkbox
    *ngFor="let value of values"
    [checked]="selectedValue === value.name"
    (change)="onValueCheckboxChange($event, value.name)"
    class="!m-0"
  >
    {{ value.name }}
  </mat-checkbox>
</div> -->

      @if (filterName === 'Sales Team') {
        <div>
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'REPORTING.Performance Metrics' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="accordion-input">
              <div class="flex flex-col">
                <!-- Bind the group value and listen for change on the group -->
                <mat-radio-group
                  [(ngModel)]="selectedMetric"
                  (change)="onMetricSelectionChange($event)"
                >
                  @for (metric of salesMetrics; track metric) {
                    <p class="!m-0">
                      <mat-radio-button [value]="metric.name" class="!m-0">
                        {{
                          getTranslatedText('REPORTING.' + metric.name) ||
                            metric.name
                        }}
                      </mat-radio-button>
                    </p>
                  }
                </mat-radio-group>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      }

      @if (filterName === 'New Quotes') {
        <div>
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'QUOTE_TEMPLATE.Interactions' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="accordion-input">
              <div class="flex flex-col">
                <!-- Bind the group value and listen for change on the group -->
                <mat-radio-group
                  [(ngModel)]="selectedInteraction"
                  (change)="onInteractionSelectionChange($event)"
                >
                  @for (metric of interactionsArray; track metric) {
                    <p class="!m-0">
                      <mat-radio-button [value]="metric.name" class="!m-0">
                        {{
                          getTranslatedText('DEAL_DETAILS.' + metric.name) ||
                            metric.name
                        }}
                      </mat-radio-button>
                    </p>
                  }
                </mat-radio-group>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      }

      @if (
        filterName === 'Top customers' ||
        filterName === 'New Quotes' ||
        filterName === 'New Leads' ||
        filterName == 'Quote -to-sales-order conversion' ||
        filterName == 'Sales Order'
      ) {
        <div>
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'REPORTING.Y Axis' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="accordion-input">
              <div class="flex flex-col">
                <!-- Bind the group value and listen for change on the group -->
                <mat-radio-group
                  [(ngModel)]="selectedAxis"
                  (change)="onAxisSelectionChange($event)"
                >
                  @for (metric of yAxis; track metric) {
                    <p class="!m-0">
                      <mat-radio-button [value]="metric.value" class="!m-0">
                        {{ metric.label }}
                      </mat-radio-button>
                    </p>
                  }
                </mat-radio-group>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      }

      <!-- <div *ngIf="filterName === 'Quote -to-sales-order conversion'">
  <mat-expansion-panel class="py-2">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ "Currency" | translate }}</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="accordion-input p-2">
      <div class="flex flex-col">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ "Select Currency" | translate }}</mat-label>
          <mat-select
            [(ngModel)]="selectedViews"
            (selectionChange)="onViewsSelectionChange($event)"
          >
          <mat-option>
            <ngx-mat-select-search
              placeholderLabel="Search"
              noEntriesFoundLabel="'No match found'"
              [(ngModel)]="searchValue"
              (ngModelChange)="onSearchValueChange($event)"
            ></ngx-mat-select-search>
          </mat-option>
    <mat-option [value]=""></mat-option>
            <mat-option *ngFor="let metric of currencyArr" [value]="metric.currency_symbol">
              {{ metric.currency_code }} - {{ metric.currency_symbol }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-expansion-panel>
</div> -->

      @if (filterName === 'Top customers') {
        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'SYSTEM_USER.Top Contacts' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (item of topCustomersLimits; track item) {
                  <p class="!h-[28px]">
                    @if (item?.name) {
                      <mat-checkbox
                        [checked]="selectedLimit.includes(item.name)"
                        (change)="toggleLimitValue($event, item)"
                        class="!m-0"
                      >
                        {{ item?.name }}
                      </mat-checkbox>
                    }
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>
      }

      <!-- <div *ngIf="filterName == 'Sales overview'">
  <mat-expansion-panel class="py-2">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ "Document Type" | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="acordion-input">
      <div class="flex flex-col">
        <mat-checkbox
          *ngFor="let value of values"
          [checked]="selectedValue === value.name"
          (change)="onValueCheckboxChange($event, value.name)"
          class="!m-0"
        >
          {{ value.name }}
        </mat-checkbox>
      </div>
    </div>
  </mat-expansion-panel>
</div> -->
    </mat-accordion>
  </div>

  <div class="flex gap-3 items-center p-3 w-full">
    <button
      class="px-4 py-2 bg-[#fff] text-[#92A0A8] rounded-md w-[40%] border-[#CBDBE4]"
      (click)="clearFilter()"
    >
      &#x25C9; {{ 'COMMON.Cancel_Filter' | translate }}
    </button>
    <button
      class="px-4 py-2 bg-[#03C0FC] text-white rounded-md w-[60%] border-none outline-none"
      (click)="applyFilter()"
    >
      &#x25BA; {{ 'COMMON.Apply_Filter' | translate }}
    </button>
  </div>
</div>
